export default __webpack_public_path__ + "static/media/CK.9396abdd.svg";